import classNames from 'classnames';
import { observer } from 'mobx-react';
import React from 'react';
import { Button, Modal } from 'react-bootstrap';

export interface IYesNoConfirmModal {
  visible: boolean;
  backdrop?: 'static';
  busy: boolean;
  title: string | React.ReactNode;
  description: React.ReactNode | string | JSX.Element;
  confirmButtonText?: string;
  cancelButtonText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  size?: 'sm' | 'lg' | 'xl' | undefined;
}

export const YesNoConfirmModal = observer(
  ({
    visible,
    backdrop = 'static',
    title,
    description,
    busy,
    confirmButtonText = 'Yes',
    cancelButtonText = 'Cancel',
    onConfirm,
    onCancel,
    size,
  }: IYesNoConfirmModal) => {
    React.useEffect(() => {
      if (visible) {
        const el = document.getElementsByClassName('fade modal-backdrop show');
        requestAnimationFrame(() => {
          if (el.length > 0 && (el[1] as HTMLElement)?.style) {
            (el[1] as HTMLElement).style.zIndex = '1070';
          }
        });
      }
    }, [visible]);
    return (
      <Modal
        style={{ zIndex: 1071 }}
        backdrop={backdrop}
        centered
        size={size}
        className="confirm-dialog test"
        data-testid="confirm-dialog"
        show={visible}
        onHide={onCancel}
      >
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mt-3">{description}</div>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-end align-items-center">
          <Button
            variant="light"
            className={classNames('cancel', 'text-uppercase')}
            disabled={busy}
            onClick={onCancel}
          >
            {cancelButtonText}
          </Button>
          <Button
            variant="primary"
            className={classNames(
              'confirm',
              'text-uppercase',
              busy ? 'button-loading' : '',
            )}
            disabled={busy}
            onClick={onConfirm}
          >
            {confirmButtonText}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  },
);
